<template>
  <IModal>
    <p :class="$style.title">再出品通知に登録しました</p>
    <p :class="$style.text">メールが届かない場合、ご入力いただいたメールアドレスに誤りがある、またはiichi.comのドメイン許可設定がされていない場合がございます。</p>
  </IModal>
</template>

<script setup lang="ts">
import IModal from '@/js/components/molecules/IModal.vue';
</script>

<style module lang="scss">
.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}

.text {
  text-align: left;
}
</style>
